import WhatsAppMessage from './WhatsAppMessage';
export default WhatsAppMessage;
